<template>
  <Vcode :show="isShow"
         slider-text="Drag Slider to Complete Puzzle"
         fail-text="Verification Failed, Please Try Again"
         success-text="Verification Passed"
         :range="5"
         @success="onSubmitLogin"
         @close="close"
  />
  <van-toast v-model:show="loading" type="loading" overlay="true" duration="0"
             forbid_click="true" message="Loading..."></van-toast>
  <div style="margin-top: 7vh">
    <center>
      <div style="width: 96px; height: 96px; margin: 0 auto 18px; border: 2px solid #1989fa; border-radius: 50%; color: #1989fa; display: flex; align-items: center; justify-content: center; font-size: 30px; font-weight: 700;">CF</div>
      <h2 style="margin-bottom: -15px">CourtFlow</h2>
      <h4>学员训练管理</h4>
      <h3>欢迎使用</h3>
    </center>
    <center>
      <van-button round block icon="sign" :disabled="disabled" type="success" @click="onLogin" style="width: 80%; max-width: 320px; margin: 8pt; margin-top: 20pt">快捷登录</van-button>
      <van-button round block icon="manager-o" :disabled="disabled" type="success" @click="this.$router.push('/login');"
                  style="width: 80%; max-width: 320px; margin: 8pt; background-color: dodgerblue; border-color: dodgerblue">密码登录</van-button>
      <van-button round block icon="add-o" :disabled="disabled" type="warning" @click="onRegister" style="width: 80%; max-width: 320px; margin: 8pt">注册新账户</van-button>
    </center>
  </div>

  <p style="font-size: 7pt; text-align: center; position: fixed; bottom: 5vh; width: 100%;">
    CourtFlow 学员服务<br/>
    Copyright © 2024 CourtFlow
  </p>
</template>

<script>
import Cookies from "js-cookie";
import {showToast, showSuccessToast, showFailToast, showDialog} from "vant";
export default {
  created(){
    const token = Cookies.get('token');
    if(token != null){
      this.$http.post('/user/verify?token='+ Cookies.get('token'))
          .then(response =>{
            if(response.data.status === 3)
              this.$router.push('/staff');
            else if(response.data.status > 0 && response.data.status < 3)
              this.$router.push('/main');
          }).
      catch(error =>{
      });
    }
  },
  data() {
    return {
      username: '',
      password: '',
      isShow: false,
      disabled: false,
      loading: false,
      time_call: new Date('2023-01-01T00:00:00Z')
    };
  },
  methods: {
    onLogin() {
      const now = new Date();
      if(Math.abs(now.getTime() - this.time_call.getTime()) < 5000){
        this.isShow = true;
      }
      else
        this.onSubmitLogin();
    },
    onRegister(){
      this.$router.push('/register');
    },
    async onSubmitLogin(){
      this.loading = true;
      this.time_call = new Date();
      console.log(this.$finger());
      this.isShow = false;
      this.disabled = true;
      this.username = await this.$finger();
      this.$http({
        method: 'POST',
        url: `/user/loginByEquip?equip_id=${encodeURIComponent(this.username)}`,
      }).then((response) => {
        this.disabled = false;
        if(response.data.status === -2){
          this.loading = false;
          showDialog({
                message: "Currently, “快捷登录” is not enabled on your device, you can set “快捷登录” in “One-Tap Login Management” of “My Account” after login!",
                confirmButtonText: 'Ok'
          });
          return;
        }
        if(response.data.status === -1){
          this.loading = false;
          showFailToast('The current account is still pending.');
          return;
        }
        if(response.data.status === 0){
          this.loading = false;
          showFailToast('Current account has been blocked, please contact customer service.');
          return;
        }
        if(response.data.status > 3){
          this.loading = false;
          showToast('The current account is an administrator account, please go to the backstage.');
          return;
        }
        this.loading = false;
        Cookies.set('token', response.data.data);
        if(response.data.status === 3)
          this.$router.push('/staff');
        else
          this.$router.push('/main');
        if(response.data.status === 1){
          showDialog({
            title: 'Account Restrictions',
            message: 'Hello, we are very sorry to inform you that due to your repeated participation but absence, you are temporarily unable to participate in our activities directly or by alternate, and no designated account transfer, and are only allowed to participate through designated account transfer. Please contact our customer service for a solution!',
            confirmButtonText: 'I Understand'
          }).then(() => {
            // on close
          });
        }else{
          showSuccessToast('Login Successfully');
        }
      }).catch((error) => {
          this.loading = false;
          console.log(error);
          showFailToast('Internet Error');
          this.disabled = false;
        }
      );
    },
    close(){
      this.isShow = false;
    }
  }
};
</script>
